module.exports = __webpack_public_path__ + "static/media/heart.13a5c746.svg";